import React from "react";
import { confirm } from "../../../../components/modal/comfirm";
import { textStyleSet } from "../../../../mui-theme/text.style";
import { IconFont } from "../../../../icon-font/iconfont";
import { getI18n } from "react-i18next";

export function showIosPWAReminder(t: any = getI18n().t): Promise<any> {
  return confirm({
    title: t("reminder_title"),
    confirmButtonText: t("Common.i_got_it_confirmation"),
    hideCancelButton: true,
    message: (
      <div style={textStyleSet.text_14_med} className="text-grey33 leading-5">
        <div className="mb-3 whitespace-normal break-words">
          {t("Common.suggest_add_shortcut_first_then_enable_notification")}
        </div>
        <div className="flex flex-row">
          {t("Common.you_can_click")}
          <div className="w-6 h-5 mx-1 rounded overflow-hidden">
            <IconFont name="bookmark" size={16} />
          </div>
          {t("Common.it_will_guide_you")}
        </div>
      </div>
    ),
  });
}

export function showDeniedReminder(t: any = getI18n().t): Promise<any> {
  return confirm({
    title: t("reminder_title"),
    message: t("Common.web_push_unhappy_reminder_desc"),
    confirmButtonText: t("OK"), //PHKL Custom
    hideCancelButton: true,
    messageStyle: { whiteSpace: "pre-line" },
  });
}

export function showPWAInstalledReminder(t: any = getI18n().t): Promise<any> {
  return confirm({
    title: t("reminder_title"),
    //PHKL Custom -s
    message: t("Common.launch_from_homescreen_instruction"),
    confirmButtonText: t("OK"),
    //PHKL Custom -e
    hideCancelButton: true,
  });
}
